import { render, staticRenderFns } from "./AssignProjectModal.vue?vue&type=template&id=676e6100&v-on-clickaway=cancel&"
import script from "./AssignProjectModal.vue?vue&type=script&lang=ts&"
export * from "./AssignProjectModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports